export const EnrollmentSubpops = [
  { name: "Male", field: "male", value: "M" },
  { name: "Female", field: "female", value: "F" }
]